import { render } from "./BooleanOption.vue?vue&type=template&id=33686d40"
import script from "./BooleanOption.vue?vue&type=script&lang=js"
export * from "./BooleanOption.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanOption.vue"]])

export default __exports__